import { createRouter, createWebHistory } from 'vue-router';
import AppLayout from '../layout/AppLayout.vue';
import { validateRoute } from './routeGuard';
import { useStates } from './states';
import * as PermissionType from '../enums/PermissionType';


const routes = [
    {
        path: '/',
        component: AppLayout,
        children: [
            {
                path: '/',
                name: 'dashboard',
                exact: true,
                component: () => import('@/views/dashboards/Dashboard.vue'),
                // meta: {
                //     breadcrumb: [{ label: 'Dashboard' }],
                //     permission: {
                //         moduleType: 'global',
                //         permissionFlag: PermissionType.Global.DASHBOARD
                //     }
                // }
            },
            {
                path: '/users',
                name: 'users',
                exact: true,
                component: () => import('@/views/user/Users.vue'),
                meta: {
                    breadcrumb: [{ label: 'users.titleMenu' }],
                    permission: {
                        moduleType: 'users',
                        permissionFlag: PermissionType.Users.READ
                    }
                }
            },
            {
                path: '/companysettings',
                name: 'companysettings',
                exact: true,
                component: () => import('@/views/company-settings/CompanySettings.vue'),
                meta: {
                    breadcrumb: [{ label: 'companySettings.titleMenu' }],
                    permission: {
                        moduleType: 'configuration',
                        permissionFlag: PermissionType.Configuration.READ
                    }
                }
            },
            {
                path: '/settings/permissions',
                name: 'role-permissions',
                exact: true,
                component: () => import('@/views/settings/RolePermissionManagement.vue'),
                meta: {
                    breadcrumb: [{ label: 'permissions.management' }],
                    module: 'CONFIGURATION',
                    permission: 15, // Configuration.ALL (READ + CREATE + UPDATE + DELETE)
                    requiresAuth: true
                }
            },
            {
                path: '/help',
                name: 'help',
                exact: true,
                component: () => import('@/views/help/Help.vue'),
                meta: {
                    breadcrumb: [{ label: 'help.titleMenu' }]
                }
            },
            {
                path: '/subscription-plans',
                name: 'subscription-plans',
                exact: true,
                component: () => import('@/views/subscription/SubscriptionPlans.vue'),
                meta: {
                    breadcrumb: [{ label: 'subscription.requiresSubscription' }]
                }
            },
            {
                path: '/themes',
                name: 'themes',
                exact: true,
                component: () => import('@/layout/AppConfig.vue'),
                meta: {
                    breadcrumb: [{ label: 'appMenu.themes' }]
                }
            },
            {
                path: '/products',
                name: 'products',
                exact: true,
                component: () => import('@/views/products/Products.vue'),
                meta: {
                    breadcrumb: [{ label: 'products.titleMenu' }],
                    permission: {
                        moduleType: 'inventory',
                        permissionFlag: PermissionType.Inventory.READ
                    }
                }
            },
            {
                path: '/expenses',
                name: 'expenses',
                exact: true,
                component: () => import('@/views/products/Expenses.vue'),
                meta: {
                    breadcrumb: [{ label: 'expenses.titleMenu' }],
                    permission: {
                        moduleType: 'inventory',
                        permissionFlag: PermissionType.Inventory.READ
                    }
                }
            },
            {
                path: '/internal-inventory',
                name: 'internal-inventory',
                exact: true,
                component: () => import('@/views/products/InternalInventory.vue'),
                meta: {
                    breadcrumb: [{ label: 'internalInventory.titleMenu' }],
                    permission: {
                        moduleType: 'inventory',
                        permissionFlag: PermissionType.Inventory.READ
                    }
                }
            },
            {
                path: '/ats',
                name: 'ats',
                exact: true,
                component: () => import('@/views/billing/ATS/ATS.vue'),
                meta: {
                    breadcrumb: [{ label: 'ats.titleMenu' }],
                    permission: {
                        moduleType: 'sales',
                        permissionFlag: PermissionType.Sales.READ
                    }
                }
            },
            {
                path: '/sales-invoices',
                name: 'salesInvoices',
                exact: true,
                component: () => import('@/views/billing/Sales/Sales.vue'),
                meta: {
                    breadcrumb: [{ label: 'sales.invoices' }],
                    permission: {
                        moduleType: 'sales',
                        permissionFlag: PermissionType.Sales.READ
                    }
                }
            },
            {
                path: '/sales-notes',
                name: 'salesNotes',
                exact: true,
                component: () => import('@/views/sales-purchase-notes/sales-notes/SalesNotes.vue'),
                meta: {
                    breadcrumb: [{ label: 'sales.salesNotes' }]
                }
            },
            {
                path: '/withholdings',
                name: 'withholdings',
                exact: true,
                component: () => import('@/views/billing/withholding/Withholding.vue'),
                meta: {
                    breadcrumb: [{ label: 'sales.withholdings' }],
                    permission: { moduleType: 'configuration', permissionFlag: PermissionType.Configuration.READ },
                    requiresWithholdingAgent: true
                }
            },
            {
                path: '/proformas',
                name: 'proformas',
                exact: true,
                component: () => import('@/views/proformas/Proformas.vue'),
                meta: {
                    breadcrumb: [{ label: 'sales.proformas' }]
                }
            },
            {
                path: '/credit-notes',
                name: 'creditNotes',
                exact: true,
                component: () => import('@/views/billing/CreditNotes/CreditNotes.vue'),
                meta: {
                    breadcrumb: [{ label: 'sales.creditNotes' }]
                }
            },
            {
                path: '/debit-notes',
                name: 'debitNotes',
                exact: true,
                component: () => import('@/views/billing/DebitNotes/DebitNotes.vue'),
                meta: {
                    breadcrumb: [{ label: 'sales.debitNotes' }]
                }
            },
            {
                path: '/withholding-electronics',
                name: 'withholdingElectronics',
                exact: true,
                component: () => import('@/views/billing/WithholdingElectronics/WithholdingElectronics.vue'),
                meta: {
                    breadcrumb: [{ label: 'withholdingElectronics.title' }],
                    requiresWithholdingAgent: true
                }
            },
            {
                path: '/received-withholdings',
                name: 'receivedWithholdings',
                exact: true,
                component: () => import('@/views/billing/ReceivedWithholdings/ReceivedWithholdings.vue'),
                meta: {
                    breadcrumb: [{ label: 'receivedWithholdings.title' }]
                }
            },
            {
                path: '/waybill-remissions',
                redirect: '/waybill-remissions/emitted',
            },
            {
                path: '/waybill-remissions/carriers',
                name: 'waybillRemissionsCarriers',
                exact: true,
                component: () => import('@/views/billing/WaybillRemissions/Carriers/Carriers.vue'),
                meta: {
                    breadcrumb: [{ label: 'carriers.title' }]
                }
            },
            {
                path: '/waybill-remissions/emitted',
                name: 'waybillRemissionsEmitted',
                exact: true,
                component: () => import('@/views/billing/WaybillRemissions/WaybillRemissions.vue'),
                meta: {
                    breadcrumb: [{ label: 'waybillRemissions.emitted' }]
                }
            },
            {
                path: '/waybill-remissions/received',
                name: 'waybillRemissionsReceived',
                exact: true,
                component: () => import('@/views/billing/WaybillRemissions/WaybillRemissionsReceived.vue'),
                meta: {
                    breadcrumb: [{ label: 'waybillRemissions.received' }]
                }
            },
            {
                path: '/purchases-invoices',
                name: 'purchasesInvoices',
                exact: true,
                component: () => import('@/views/billing/shopping/Shopping.vue'),
                meta: {
                    breadcrumb: [{ label: 'purchases.invoices' }]
                }
            },
            {
                path: '/purchases-credit-notes',
                name: 'purchasesCreditNotes',
                exact: true,
                component: () => import('@/views/billing/purchaseCreditNote/PurchaseCreditNote.vue'),
                meta: {
                    breadcrumb: [{ label: 'billing.purchaseCreditNoteTitle' }]
                }
            },
            {
                path: '/purchases-debit-notes',
                name: 'purchasesDebitNotes',
                exact: true,
                component: () => import('@/views/billing/purchaseDebitNote/PurchaseDebitNote.vue'),
                meta: {
                    breadcrumb: [{ label: 'billing.purchaseDebitNoteTitle' }]
                }
            },
            {
                path: '/purchases-notes',
                name: 'purchasesNotes',
                exact: true,
                component: () => import('@/views/sales-purchase-notes/purchases-notes/PurchasesNotes.vue'),
                meta: {
                    breadcrumb: [{ label: 'purchases.purchasesNotes' }]
                }
            },
            {
                path: '/clients',
                name: 'clients',
                exact: true,
                component: () => import('@/views/client/Clients.vue'),
                meta: {
                    breadcrumb: [{ label: 'clients.titleMenu' }],
                    permission: {
                        moduleType: 'sales',
                        permissionFlag: PermissionType.Sales.READ
                    }
                }
            },
            {
                path: '/profile',
                name: 'profile',
                exact: true,
                component: () => import('@/views/profile/Profile.vue'),
                meta: {
                    breadcrumb: [{ label: 'profile.titleMenu' }]
                }
            },
            {
                path: '/suppliers',
                name: 'suppliers',
                exact: true,
                component: () => import('@/views/suppliers/Suppliers.vue'),
                meta: {
                    breadcrumb: [{ label: 'suppliers.titleMenu' }]
                }
            },
            {
                path: '/accounting/chart-of-accounts',
                name: 'chart-of-accounts',
                exact: true,
                component: () => import('@/views/accounting/ChartOfAccounts.vue'),
                meta: {
                    breadcrumb: [{ label: 'accounting.chartOfAccounts' }],
                    permission: {
                        moduleType: 'accounting',
                        permissionFlag: PermissionType.Accounting.READ
                    }
                }
            },
            {
                path: '/accounting/product-categories',
                name: 'product-categories',
                exact: true,
                component: () => import('@/views/accounting/AccountingProductCategories.vue'),
                meta: {
                    breadcrumb: [{ label: 'accounting.productCategories' }],
                    permission: {
                        moduleType: 'accounting',
                        permissionFlag: PermissionType.Accounting.READ
                    }
                }
            },
            {
                path: '/accounting/journal-entries',
                name: 'journal-entries',
                exact: true,
                component: () => import('@/views/accounting/AccountingEntries.vue'),
                meta: {
                    breadcrumb: [{ label: 'accounting.accountingEntries' }],
                    permission: {
                        moduleType: 'accounting',
                        permissionFlag: PermissionType.Accounting.READ
                    }
                }
            },
            {
                path: '/accounting/periods',
                name: 'accounting-periods',
                exact: true,
                component: () => import('@/views/accounting/AccountingPeriods.vue'),
                meta: {
                    breadcrumb: [{ label: 'accounting.accountingPeriods' }],
                    permission: {
                        moduleType: 'accounting',
                        permissionFlag: PermissionType.Accounting.READ
                    }
                }
            },
            {
                path: '/accounting/general-ledger',
                name: 'general-ledger',
                exact: true,
                component: () => import('@/views/accounting/GeneralLedger.vue'),
                meta: {
                    breadcrumb: [{ label: 'accounting.generalLedger' }],
                    permission: {
                        moduleType: 'accounting',
                        permissionFlag: PermissionType.Accounting.READ
                    }
                }
            },
            {
                path: '/accounting/journal',
                name: 'journal',
                exact: true,
                component: () => import('@/views/accounting/Journal.vue'),
                meta: {
                    breadcrumb: [{ label: 'accounting.journal' }],
                    permission: {
                        moduleType: 'accounting',
                        permissionFlag: PermissionType.Accounting.READ
                    }
                }
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/pages/auth/Login.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/pages/auth/Register.vue')
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/views/pages/auth/ForgotPassword.vue')
    },
    {
        path: '/forgot-password/:email',
        name: 'forgot-password-with-email',
        component: () => import('@/views/pages/auth/ForgotPassword.vue')
    },
    {
        path: '/recover-password/:email/:otp/:userId/:userCompanyId',
        name: 'recover-password',
        component: () => import('@/views/pages/auth/RecoverPassword.vue'),
        props: true
    },
    {
        path: '/register-user/:email/:otp/:userId/:userCompanyId',
        name: 'register-user',
        component: () => import('@/views/pages/auth/RegisterUser.vue'),
        props: true
    },
    {
        path: '/verify-otp/:email/:token',
        name: 'verify-otp',
        component: () => import('@/views/pages/auth/VerifyOtp.vue'),
        props: true
    },
    {
        path: '/complete-registration/:email/:otp/:userId/:userCompanyId',
        name: 'complete-registration',
        component: () => import('@/views/pages/auth/CompleteRegistration.vue'),
        props: true
    },
    {
        path: '/pages/no-connection',
        name: 'no-connection',
        component: () => import('../views/pages/NoConnection.vue')
    },
    {
        path: '/access-denied',
        name: 'access-denied',
        component: () => import('../views/errors/AccessDenied.vue'),
        props: route => ({
            module: route.query.module,
            requiredPermission: route.query.permission ? parseInt(route.query.permission) : undefined,
            route: route.query.route
        })
    },
    // Catch-all: sin token => login; con sub inactiva => subscription-plans; resto => '/' (validateRoute decide).
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        redirect: () => {
            try {
                const token = sessionStorage.getItem('authToken');
                if (!token) {
                    return { name: 'login' };
                }
                const { userState } = useStates();
                const userData = userState?.data?.value;
                if (userData && userData.subscriptionActive === false) {
                    return { name: 'subscription-plans' };
                }
                return { path: '/' };
            } catch (_) {
                return { path: '/' };
            }
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    }
});

router.beforeEach(async (to, from) => {
    try {
        // validateRoute ya maneja autenticación Y permisos
        const result = await validateRoute(to, from);
        return result;
    } catch (error) {
        console.error('Error en router guard:', error);
        return { name: 'login' };
    }
});

export default router;
